module.exports = __webpack_public_path__ + "img/e96e74ef070917d97fbc589ecab49d01.png";